import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router';

import PrivateRoute from '@components/PrivateRoute';
import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';

import Details from './Details';
import Home from './Home';
import EventTabs from './Tabs';

export const Events = () => (
  <IonRouterOutlet>
    <Route exact path={generateRoute(RoutePath.Event)}>
      <Redirect
        to={{
          pathname: generateRoute(RoutePath.EventList),
        }}
      />
    </Route>
    <PrivateRoute exact path={generateRoute([RoutePath.EventCheck, RoutePath.EventPeopleSearch])}>
      <EventTabs />
    </PrivateRoute>
    <PrivateRoute exact path={generateRoute(RoutePath.EventDetail)}>
      <Details />
    </PrivateRoute>
    <PrivateRoute path={generateRoute(RoutePath.EventList)}>
      <Home />
    </PrivateRoute>
  </IonRouterOutlet>
);
